import { render, staticRenderFns } from "./BgIllustration.vue?vue&type=template&id=35b70133&scoped=true&"
import script from "./BgIllustration.vue?vue&type=script&lang=js&"
export * from "./BgIllustration.vue?vue&type=script&lang=js&"
import style0 from "./BgIllustration.vue?vue&type=style&index=0&id=35b70133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b70133",
  null
  
)

export default component.exports